import WebData from '../Helpers/WebData';

const initialState = [];

const productReducer = (state = initialState, action) => {
    switch(action.type){
        case 'GET_PRODUCTS':
            return WebData.products.filter(({category}) => category === action.payload);

        default: return state
    }
}

// Actions
export const getProducts = (category) => {
    return {
        type: 'GET_PRODUCTS',
        payload: category
    }
}

export default productReducer;